import Vue from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/icons"; // icon

import "@/assets/styles/index.less"; // global css

// 引入Ant Design Vue中的icon
import { Icon } from "ant-design-vue";

import Global from "./utils/global";
// 引入vxe-table 插件
import './plugins/vxe-table'
// import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
// start 引入 aj-report
// element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import echarts from "echarts";
// 全局定义echarts
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
Vue.component("v-chart", ECharts);
// 
import VueDraggableResizable from 'vue-draggable-resizable'
Vue.component('vue-draggable-resizable', VueDraggableResizable)

// enable element zh-cn
Vue.use(ElementUI, { zhLocale });
// register global mixins.
import mixins from "@/mixins";
Vue.mixin(mixins);
// permission control
// import "@/permission";
// 按钮权限的指令
import permission from "@/components/Permission/index";
Vue.use(permission);


// end  aj-report
// 这个iconfont.js就是从iconfont.cn网站上下载后的解压JS文件
import iconFronts from "@/assets/iconfont/iconfont.js";
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: iconFronts,
});
// 引用
Vue.component("IconFont", IconFont);
// 直接是ID名 <icon-font type = "iconpingtaishuju" / >'

Vue.use(Antd);
Vue.use(Global);
// Vue.use(LottieVuePlayer);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
